import type { ReactElement } from 'react'

import './styles.scss'

const AnimatedDots = (): ReactElement => {
  return <div className="animated-dots-component" />
}

export default AnimatedDots
